export const ICON_DARK = 'FFFFFF';
export const ICON_LIGHT = '181800';
export const ICON_SIZE = '44px';
export const NAVIGATION_HEIGHT = 60;
export const HOME_ICON_PATH =
  'M22 10.4108C22 10.1149 21.869 9.83427 21.6422 9.64427L12.6422 2.10397C12.2707 1.79267 11.7293 1.79267 11.3578 2.10397L2.35779 9.64427C2.13101 9.83427 2 10.1149 2 10.4108V21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21V10.4108Z';
